/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var wd_wide = 1220;
var wd_pc = 960;
var wd_tab = 800;
var wd_sp = 600;
var partslide = false; //flexslider for design parts

//css<->js width ずれ補正
function viewport() {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

function hideMenu() {
    var gn = $("#gnav ul");
    gn.removeClass("vis-gn");
    $("#close-menu").hide();
    $("#overlay").fadeOut("fast", function () {
        $("#overlay").remove();
    });
}

function change_wh() {
    //console.log("changewh");
    //console.log(viewport());
    var vwidth = viewport().width;
    /*リサイズ処理*/
    if ($("#overlay").is(":visible")) hideMenu();

    //imgswap();//とりあえずなしに
    //$("#side-sub").css("marginTop", $("#scroll").height()+"px");

    //description調整
    if ($(".site-description").css("float") == "left") {
        $(".site-description").css("marginTop", $(".site-title").height() - $(".site-description").height() - 3 + "px");
    } else {
        $(".site-description").css("marginTop", 0);
    }
    //thumbs-list高さ
    /*$("ul#thumbs-list > li").css("height", $("ul#thumbs-list > li").width()+"px");
    $("ul#thumbs-list > li > a").each(function(){
        var img = new Image();
        img.src = $("img", $(this)).attr("src");
        //alert(img.width);
        if(img.width >= img.height){
            $("img", $(this)).css("width",img.width/img.height*100+"%");
            $("img", $(this)).css("maxWidth","none");
        }else{
            $("img", $(this)).css("height",img.height/img.width*100+"%");
            $("img", $(this)).css("maxHeight","none");
        }
    });*/

    var fblink0 = '<iframe src="//www.facebook.com/plugins/likebox.php?href=https%3A%2F%2Fwww.facebook.com%2Firiepict.mamoshi&amp;width&amp;height=290&amp;colorscheme=light&amp;show_faces=true&amp;header=true&amp;stream=false&amp;show_border=true&amp;appId=242494635794643" scrolling="no" frameborder="0" style="border:none; overflow:hidden; height:290px;" allowTransparency="true"></iframe>';
    var fblink = '<iframe src="//www.facebook.com/plugins/likebox.php?href=https%3A%2F%2Fwww.facebook.com%2Firiepict.mamoshi&amp;width&amp;height=336&amp;colorscheme=light&amp;show_faces=true&amp;header=true&amp;stream=false&amp;show_border=true&amp;appId=242494635794643" scrolling="no" frameborder="0" style="border:none; overflow:hidden; height:336px;" allowTransparency="true"></iframe>';
    var fblink_lt = '<iframe src="//www.facebook.com/plugins/likebox.php?href=https%3A%2F%2Fwww.facebook.com%2Firiepict.mamoshi&amp;width&amp;height=65&amp;colorscheme=light&amp;show_faces=false&amp;header=true&amp;stream=false&amp;show_border=true&amp;appId=242494635794643" scrolling="no" frameborder="0" style="border:none; overflow:hidden; height:65px;" allowTransparency="true"></iframe>';

    //ワイド
    /*if(vwidth >= wd_wide){
        
    }*/
    //ベース
    if (vwidth < wd_wide && vwidth > wd_tab) {}
    //タブレット以下
    if (vwidth <= wd_tab) {} else {}
    //スマホ以上
    if (vwidth >= wd_sp) {} else {}

    //fb
    if (vwidth <= wd_sp) {
        if ($("#fb-like-box iframe").height() > 65) {
            $("#fb-like-box").html(fblink_lt);
        }
    } else if (vwidth >= wd_wide) {
        if ($("#fb-like-box iframe").height() < 336) {
            //$("#fb-like-box").html(fblink);
        }
    } else {
        if ($("#fb-like-box iframe").height() > 290 || $("#fb-like-box iframe").height() <= 65) {
            //$("#fb-like-box").html(fblink0);
        }
    }

    //他表示制御
    if ($(".illust-spec").is(':visible')) {
        $("#thumbs-list>li").css("height", $("#thumbs-list>li").width() + 60 + "px");
    } else {
        $("#thumbs-list>li").css("height", "auto");
    }
    if ($("#thumb-list-s").length) $("#footer").css("paddingBottom", "90px");

    //正方形トリミング用
    //var square_box = $("#new-illust-top,#recent-illust-top>li,.thumbnail, #thumbs-list .entry-thumb");
    //正方形サムネルの場合はコメントアウト
    //スマホで特に処理が重いのでなるべく使わない
    /*square_box.each(function(i){
        //console.log(i);
        $(this).css("textAlign", "center");
        $(this).css("height", $(this).width()+"px");
        var thumbimg = $("img", this);
        thumbimg.css("position", "relative");
        if(thumbimg.height() >= thumbimg.width()){
            var imgy = ($(this).height()-thumbimg.height())/2;
            //console.log(imgy);
            thumbimg.css("top", imgy+"px");
        }else{
            thumbimg.css("width", "auto");
            thumbimg.css("height", "100%");
            var imgx = ($(this).width()-thumbimg.width())/2;
            thumbimg.css("left", imgx+"px");
        }
    });*/

    //★トリミング後？
    if (vwidth <= wd_wide) {
        $("#newNote .thumbnail").css("height", $("#newNote .thumbnail").width() / 3 + "px");
        $("#newNote .thumbnail img").css("marginTop", -($("#newNote .thumbnail").width() / 3) + "px");
    } else {
        $("#newNote .thumbnail").css("height", "auto");
        $("#newNote .thumbnail img").css("marginTop", 0);
    }
    //スマホ用サムネイル付リスト
    if (vwidth <= wd_sp) {
        $(".entry-thumbnail img").css("marginTop", -($(".entry-thumbnail").width() / 4) + "px");
    } else {
        $(".entry-thumbnail img").css("marginTop", 0);
    }
    $(".flex-control-nav").css("bottom", $("#thumb-list-s .flex-viewport").height() + "px");

    //gnav
    var plusmenu = '<li class="plus"><a href="/inq/?type=contact">お問合せ</a></li>';
    plusmenu += '<li class="plus"><a href="/inq/?type=custom">お申込み(カスタム)</a></li>';
    plusmenu += '<li class="plus"><a href="/inq/?type=fullorder">お申込み(フルオーダー)</a></li>';
    if (vwidth <= wd_sp) {
        if (!$("ul#menu-global-iw .plus").length) $("ul#menu-global-iw").append(plusmenu);
    } else {
        $("ul#menu-global-iw .plus").remove();
    }

    //parts-design
    if ($("ul.parts-design").length) {
        parts_thumb($("#pd-pose ul.parts-design"));
        parts_thumb($("#pd-back ul.parts-design"));
        parts_thumb($("#pd-wear ul.parts-design"));
        parts_thumb($("#pd-title ul.parts-design"), 200, 150);
    }

    //thanks
    if (vwidth > wd_sp) {
        $(".prepare-mail").css("height", $(".prepare-photo").height() - 20 + "px");
    } else {
        $(".prepare-mail").css("height", "auto");
    }
}

/*
function imgswap(){
    //console.log("imgswap");
    if(viewport().width <= wd_tab){
        if(viewport().width <= wd_sp){
            $('img.spswap').each(function() {
                var t = $(this);
                t.attr('src', t.attr('src').replace(/@tb/, ""));
                if(!t.attr('src').match(/@sp/)) t.attr('src', t.attr('src').replace(/(\.[a-z]+)$/i, "@sp$1"));
            });
            //$(window).unbind('scroll',scrl);
            //$("#scroll").css("top", "0");
        }else{
            $('img.spswap').each(function() {
                var t = $(this);
                t.attr('src', t.attr('src').replace(/@sp/, ""));
                if(!t.attr('src').match(/@tb/)) t.attr('src', t.attr('src').replace(/(\.[a-z]+)$/i, "@tb$1"));
            });
            //$(window).unbind('scroll',scrl);
            //$("#scroll").css("top", "0");
        }
    }else{
        $('img.spswap').each(function() {
            var t = $(this);
            t.attr('src', t.attr('src').replace(/@tb/, ""));
            t.attr('src', t.attr('src').replace(/@sp/, ""));
        });
        //$(window).bind('scroll',scrl);
    }
    //console.log($('img.spswap').attr("src"));
}
*/
function parts_thumb(target, tmax, tmin) {
    var target_ul = target;
    var maxw = tmax || 135;
    var minw = tmin || 80;
    var parts_li = $("li", target_ul);
    var parts_li_wd_mg = parts_li.width() + (parts_li.css("marginLeft").replace("px", "") - 0) + (parts_li.css("marginRight").replace("px", "") - 0);
    var cols = Math.round(target_ul.width() / parts_li_wd_mg);
    var cols_new;
    if (parts_li.width() > maxw) {
        cols_new = Math.ceil(target_ul.width() / maxw);
        parts_li.css("width", (100 - 1 * cols_new) / cols_new + "%");
    }
    if (parts_li.width() < minw) {
        cols_new = Math.ceil(target_ul.width() / minw);
        parts_li.css("width", (100 - 1 * cols_new) / cols_new + "%");
    }
}

//------------------------
$(function () {
    ///////////////////////////////
    var isTouch = document.createTouch !== undefined || 'ontouchstart' in window || 'onmsgesturechange' in window || navigator.msMaxTouchPoints;
    /*if (window.devicePixelRatio > 1){
        $('img').each(function() {
            var t = $(this);
            if(!t.hasClass('no2x')) t.attr('src', t.attr('src').replace(/(\.[a-z]+)$/i, "@2x$1"));
        });
    }*/
    /*if($(window).width() < mintabw){
        $('img.spswap').each(function() {
            var t = $(this);
            if(!t.attr('src').match(/@sp/)) t.attr('src', t.attr('src').replace(/(\.[a-z]+)$/i, "@sp$1"));
        });
    }*/
    ///////////////////////////////
    var isAndroid = navigator.userAgent.indexOf('Android') != -1;
    //201410イベントタイミングがandroidは変更前なので・・
    if (_typeof(window.onorientationchange) === 'object' && !isAndroid) {
        $(window).bind('orientationchange', function () {
            change_wh();
        });
    } else {
        $(window).bind('resize', function () {
            change_wh();
        });
    }
    ///////////////////////////////

    //svg
    // if (!Modernizr.svg){
    //     var imgzr = $("img[data-no-svg]");
    //     imgzr.each(function() {
    //         $(this).attr("src",$(this).data("noSvg"));
    //     });
    // }

    //anchor
    $(".sscrl a, a.sscrl").click(function () {
        $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top
        }, 'fast', 'swing');
        return false;
    });

    $("#gnav h3").click(function () {
        var gn = $("#gnav ul");
        if (!$("#overlay").length) $("#gnav").append('<div id="overlay"></div>');
        $("#overlay").css("height", $("html").height() + "px");
        gn.addClass("vis-gn");
        $("#close-menu").show();
        $("#overlay,#close-menu").click(function () {
            hideMenu();
        });
        return false;
    });
    $("#show-size").click(function () {
        $.ajax({
            url: '../wp-content/themes/iw2014/temp/size.html',
            dataType: 'html'
            //data: {param1: 'value1'},
        }).done(function (html) {
            //console.log("success"+html);
            if (!$("#size-AB").length || !$("#size-AB").is(":visible")) {
                if (!$("#size-AB").length) $("#show-size").parent().after(html);
                $("#size-AB").hide();
                $("#size-AB").slideDown('fast');
            } else {
                $("#size-AB").slideUp('fast');
            }
        });
        return false;
    });
});

$(window).load(function () {
    if ($('body').flexslider) {
        $('#top-visual').flexslider({
            animation: "fade",
            slideshowSpeed: 3000,
            animationSpeed: 300,
            slideshow: false,
            directionNav: false,
            controlNav: false,
            randomize: true,
            start: change_wh
        });
        $('#thumb-list-s').flexslider({
            animation: "slide",
            animationLoop: false,
            slideshow: false,
            itemWidth: 75,
            itemMargin: 0,
            minItems: 5,
            maxItems: 25,
            directionNav: false,
            start: change_wh
        });
        if (viewport().width <= wd_sp) {
            //smartphone_flex();
        }

        if (!($('#top-visual').length || $('#thumb-list-s').length)) {
            change_wh();
        }
    }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/common.js